/** Shared copy and date helpers for 給与明細書等電子交付同意書 (modal + PDF). */

export const CONSENT_APP_URL = 'https://meisai.saigyo.com/';

const TOKYO_TZ = 'Asia/Tokyo';

const MS_PER_DAY = 86_400_000;

export function getTokyoYmd(forDate: Date): { y: number; m: number; d: number } {
  const parts = new Intl.DateTimeFormat('ja-JP', {
    timeZone: TOKYO_TZ,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(forDate);
  const y = parseInt(parts.find((p) => p.type === 'year')?.value ?? '0', 10);
  const m = parseInt(parts.find((p) => p.type === 'month')?.value ?? '0', 10);
  const d = parseInt(parts.find((p) => p.type === 'day')?.value ?? '0', 10);
  return { y, m, d };
}

/** Calendar date in Japan (Asia/Tokyo) as 令和n年m月d日 (or 平成 before 2019-05-01). */
export function formatJapanEraDate(forDate: Date): string {
  const { y, m, d } = getTokyoYmd(forDate);
  const isReiwa = y > 2019 || (y === 2019 && m >= 5);
  if (isReiwa) {
    return `令和${y - 2018}年${m}月${d}日`;
  }
  return `平成${y - 1988}年${m}月${d}日`;
}

export function addDays(base: Date, days: number): Date {
  return new Date(base.getTime() + days * MS_PER_DAY);
}
